"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = retrieveCareTeamsMock;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var items = [{
  organization: 'Foo A1',
  organizationPhone: 'Foo B',
  careManager: 'Foo C',
  careManagerPhone: 'Foo D',
  pcp: 'Foo E'
}, {
  organization: 'Foo A2',
  organizationPhone: 'Foo B',
  careManager: 'Foo C',
  careManagerPhone: 'Foo D',
  pcp: 'Foo E'
}, {
  organization: 'Foo A3',
  organizationPhone: 'Foo B',
  careManager: 'Foo C',
  careManagerPhone: 'Foo D',
  pcp: 'Foo E'
}, {
  organization: 'Foo A4',
  organizationPhone: 'Foo B',
  careManager: 'Foo C',
  careManagerPhone: 'Foo D',
  pcp: 'Foo E'
}, {
  organization: 'Foo A5',
  organizationPhone: 'Foo B',
  careManager: 'Foo C',
  careManagerPhone: 'Foo D',
  pcp: 'Foo E'
}, {
  organization: 'Foo A6',
  organizationPhone: 'Foo B',
  careManager: 'Foo C',
  careManagerPhone: 'Foo D',
  pcp: 'Foo E'
}, {
  organization: 'Foo A7',
  organizationPhone: 'Foo B',
  careManager: 'Foo C',
  careManagerPhone: 'Foo D',
  pcp: 'Foo E'
}, {
  organization: 'Foo A8',
  organizationPhone: 'Foo B',
  careManager: 'Foo C',
  careManagerPhone: 'Foo D',
  pcp: 'Foo E'
}, {
  organization: 'Foo A9',
  organizationPhone: 'Foo B',
  careManager: 'Foo C',
  careManagerPhone: 'Foo D',
  pcp: 'Foo E'
}, {
  organization: 'Foo A10',
  organizationPhone: 'Foo B',
  careManager: 'Foo C',
  careManagerPhone: 'Foo D',
  pcp: 'Foo E'
}, {
  organization: 'Foo A11',
  organizationPhone: 'Foo B',
  careManager: 'Foo C',
  careManagerPhone: 'Foo D',
  pcp: 'Foo E'
}];
function retrieveCareTeamsMock(_ref) {
  var resolve = _ref.resolve;
  setTimeout(function () {
    resolve(items);
  }, 1000);
}
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(items, "items", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/mock/retrieve-care-teams.mock.js");
  reactHotLoader.register(retrieveCareTeamsMock, "retrieveCareTeamsMock", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/mock/retrieve-care-teams.mock.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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